import { useCallback, useState } from 'react'
import api from '@/api/index'
import { useToast } from '@/hooks'
import useIsOpen from '@/hooks/useIsOpen'
import { t } from '@/i18n'
import { download } from '@/utils/index'
import CarLicenseUploadModal from '../modals/CarLicenseUploadModal'
import DealInvoicesExportModal from '../modals/DealInvoicesExportModal'
import { exportMenus } from './AdditionalFunctionsMenu'

export const useAdditionalFunctionsHandlers = () => {
  const addToast = useToast()
  const [downloading, setDownloading] = useState<boolean>(false)
  const [handling, setHandling] = useState<boolean>(false)
  const [menuAnchorEl, setMenuAnchorEl] = useState<HTMLElement | null>(null)

  const {
    isOpen: isDealInvoicesExportOpen,
    open: openDealInvoicesExport,
    close: closeDealInvoicesExport,
  } = useIsOpen(false)

  const {
    isOpen: isCarLicenseUploadOpen,
    open: openCarLicenseUpload,
    close: closeCarLicenseUpload,
  } = useIsOpen(false)

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setMenuAnchorEl(null)
  }

  const onExport = useCallback(
    (link: string, name: string) => {
      if (name === 'deal_invoices') {
        openDealInvoicesExport()
        return
      }
      if (name === 'car_licences_file_import') {
        openCarLicenseUpload()
        return
      }
      addToast('info', t('exporting_in_background'))
      setDownloading(true)
      api
        .get<any>(link, {}, {}, { responseType: 'arraybuffer' })
        .then(res => {
          download(res.data, `${t(name)}.xlsx`)
        })
        .finally(() => {
          setDownloading(false)
        })
    },
    [addToast, openDealInvoicesExport, openCarLicenseUpload],
  )

  const onHandleIntegration = useCallback(
    (path: string, name: string) => {
      if (
        [
          'send_invoice',
          'stream_invoices',
          'stream_customers',
          'stream_toll_road_invoices',
        ].includes(name)
      ) {
        addToast('info', t('loading'))
        setHandling(true)
        api.post<any>(path).finally(() => {
          setHandling(false)
        })
      } else if (name === 'print_not_sent_invoices') {
      } else if (name === 'set_invoices_as_sent') {
        api.post<any>(path).finally(() => {
          setHandling(false)
        })
        addToast('info', t('invoice_sending'))
      }
    },
    [addToast],
  )

  const handleMenuItemClick = (path: string, name: string) => {
    if (exportMenus.some(item => item.name === name)) {
      onExport(path, name)
      if (name !== 'deal_invoices' && name !== 'car_licences_file_import') {
        handleMenuClose()
      }
    } else {
      onHandleIntegration(path, name)
      handleMenuClose()
    }
  }

  return {
    downloading,
    handling,
    menuAnchorEl,
    isDealInvoicesExportOpen,
    isCarLicenseUploadOpen,
    handleMenuClick,
    handleMenuClose,
    handleMenuItemClick,
    closeDealInvoicesExport,
    closeCarLicenseUpload,
  }
} 